<template lang="pug">
#modalInstalation.modal.fade(tabindex='-1')
  .modal-dialog.modal-xl
    .modal-content.rounded
      .modal-header.justify-content-end.border-0.pb-0
        .btn.btn-sm.btn-icon.btn-active-color-primary(data-bs-dismiss='modal')
          span.svg-icon.svg-icon-1
            svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none')
              rect(opacity='0.5' x='6' y='17.3137' width='16' height='2' rx='1' transform='rotate(-45 6 17.3137)' fill='black')
              rect(x='7.41422' y='6' width='16' height='2' rx='1' transform='rotate(45 7.41422 6)' fill='black')
      .modal-body.pt-0.pb-15.px-5.px-xl-20
        .mb-13.text-center
          h1.mb-3 Instalação
          .text-muted.fw-bold.fs-5
            | Caso tenha alguma dúvida sobre como instalar 
            router-link.link-primary.fw-bolder(:to="{ name: 'supportIntegrations' }" target="_blank") utilize o nosso suporte
            | .
        .d-flex.flex-column
          .nav-group.nav-group-outline.mx-auto(data-kt-buttons='true')
            a.btn.btn-color-gray-400.btn-active.btn-active-secondary.px-6.py-3.me-2(:class="{ 'active' : isActive('manual') }" @click="newInstalationMethod('manual')") Manual
            a.btn.btn-color-gray-400.btn-active.btn-active-secondary.px-6.py-3(:class="{ 'active' : isActive('integration') }" @click="newInstalationMethod('integration')") Via plugin
          .row.mt-10(v-if="instalationMethod == 'manual'")
            .col-lg-12.mb-10.mb-lg-0
              .mb-13
                h1.mb-3 Primeiro passo
                .text-muted.fw-bold.fs-5
                  p Copie e cole a nossa tag para inserir no seu site.
                .d-flex.align-items-center
                  input#codeJS.form-control.form-control-solid.me-3.flex-grow-1.d-block(type='hidden' name='search' :value="jsCode")
                  pre.mb-0(v-highlightjs="jsCode")
                    code.javascript.px-4.py-4
                  button#kt_share_earn_link_copy_button.btn.btn-light.fw-bolder.flex-shrink-0(@click="copyCode('#codeJS')") Copiar
              .mb-13
                h1.mb-3 Segundo passo
                .text-muted.fw-bold.fs-5
                  p Incluir a tag copiada no passo anterior logo após a abertura da tag &ltbody&gt conforme exemplo abaixo.
                .d-flex.align-items-center
                  pre(v-highlightjs="bodyCode")
                    code.javascript

          .row.mt-10(v-if="instalationMethod == 'integration'")
            .col-lg-12.mb-10.mb-lg-0
              .mb-13
                h1.mb-3 Primeiro passo
                .text-muted.fw-bold.fs-5
                  p Esta e a chave (key) que você deverá informar dentro das configurações do plugin de integração.
                .d-flex.align-items-center
                  input#codeHash.form-control.form-control-solid.me-3.flex-grow-1(type='hidden' name='search' :value='hash')
                  pre.mb-0(v-highlightjs="hash")
                    code.javascript.px-4.py-4
                  button#kt_share_earn_link_copy_button.btn.btn-light.fw-bolder.flex-shrink-0(@click="copyCode('#codeHash')") Copiar            
                          
        .d-flex.flex-center.flex-row-fluid.pt-12
          button.btn.btn-primary(type='reset' data-bs-dismiss='modal') Fechar

</template>

<script>
import JwtService from "@/core/services/JwtService.ts";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ModalInstalation",

  props: {
    details: { type: Object, required: true },
  },

  data() {
    return {
      instalationMethod: "manual",
    };
  },

  computed: {
    hash() {
      return JwtService.generateToken({
        account: this.details._id,
      });
    },

    jsCode() {
      return (
        "<" +
        "script" +
        ' src="https://consensu.io/bundle.min.js" key="' +
        this.hash +
        '" type="text/javascript" charset="utf-8"></' +
        "script" +
        ">"
      );
    },

    bodyCode() {
      return `
      <html>
      <head></head>\n
      <body>\n
      <!-- Seu Site --->\n
      <!-- Consensu.io Tag --->\n
      ${this.jsCode}\n
      </body>\n
      </html>
      `;
    },
  },

  methods: {
    isActive(method) {
      return method == this.instalationMethod;
    },

    newInstalationMethod(method) {
      this.instalationMethod = method;
    },

    copyCode(id) {
      const codeJS = document.querySelector(id);

      codeJS.setAttribute("type", "text"); // 不是 hidden 才能複製
      codeJS.select();

      try {
        let successful = document.execCommand("copy");
        let msg = successful
          ? "Tag copiada com sucesso!"
          : "Tag copiada com sucesso!";
        Swal.fire({
          text: msg,
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
          heightAuto: false,
        });
        // alert('Testing code was copied ' + msg);
      } catch (err) {
        // alert('Oops, unable to copy');
      }

      codeJS.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
};
</script>

<style></style>
